import { register } from '@shopify/theme-sections'
import $ from 'jquery'
import '../../styles/sections/index-hero-image.scss'

export default register(`index-hero-image`, {
  onLoad() {
    const RangeSlider = function(){
      let slider = $(`.range-slider`),
          range = $(`.range-slider__range`),
          value = $(`.range-slider__value`)

      slider.each(() =>{

        value.each(function(){
          let value = $(this).prev().attr(`value`)
          $(this).html(value)
        })

        range.on(`input`, function(){
          $(this).next(value).html(this.value)
        })
      })
    }

    RangeSlider()
  },

  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload() {
  },
})

